export default function inIframe() {
    if (typeof window === 'undefined') return false;
    
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}
